export default __webpack_public_path__ + "static/media/ic_haiti.ecd49da6.svg";